import moment from 'moment'

export const DUE_STATES = {
  overdue: 'overdue',
  dueToday: 'due-today',
  dueTomorrow: 'due-tomorrow',
  dueSoon: 'due-soon',
  upcoming: 'upcoming',
} as const

export type DueDateState = (typeof DUE_STATES)[keyof typeof DUE_STATES]

export function dueDateState(dueDate: moment.Moment): DueDateState {
  const today = moment().startOf('day')
  const tomorrow = moment().startOf('day').add('1', 'days')
  const fiveDaysFromNow = moment().endOf('day').add('5', 'days')
  const dayDueDate = dueDate.clone().startOf('day')

  if (dayDueDate.isBefore(today)) {
    return DUE_STATES.overdue
  }

  if (dayDueDate.isSame(today, 'day')) {
    return DUE_STATES.dueToday
  }

  if (dayDueDate.isSame(tomorrow, 'day')) {
    return DUE_STATES.dueTomorrow
  }

  if (dayDueDate.isBetween(today, fiveDaysFromNow)) {
    return DUE_STATES.dueSoon
  }

  return DUE_STATES.upcoming
}
